import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { Venue, VenueDetailResponse, VenueListResponse } from 'src/app/models/venue.model';
import { map } from 'rxjs/operators';
import { API } from 'aws-amplify';


@Injectable({
  providedIn: 'root'
})
export class VenueService {

  getVenues(): Observable<VenueListResponse> {
    return from(API.get('portal', 'venues', {})).pipe(
      map((venueList: any) => {
        const isPartialVenueList = venueList.isComplete;

        const venueDetails = venueList.data?.map(({ id, name, shortDesc, location }) => ({
          venueId: id,
          venueName: name,
          shortDesc: shortDesc,
          location: location,
          isComplete: isPartialVenueList
        }));

        return { venus: venueDetails } as VenueListResponse;
      })
    );
  }


  getVenueById(venueId: string): Observable<VenueDetailResponse> {
    return from(API.get('portal', `venues?id=${venueId}`, {})).pipe(
      map(details => {
        const original = details?.data[0];
        const isPartialVenueList = details?.isComplete;
        let mapped = {
          venueId: original.id,
          venueName: original.name,
          shortDesc: original.shortDesc,
          longDesc: original.longDesc,
          location: original.location,
          key: original.key,
          menuTitle: original.menuTitle,
          links: original.menuLink,
          menuAlertMessage: original.menuAlertMessage,
          hours: original.hours,
          isComplete: isPartialVenueList
        };
        return { venus: mapped ? [mapped] : [] } as VenueDetailResponse;
      })
    );
  }

  updateVenue(venue: Venue): Observable<any[]> {
    const venuePayload = {
      ...venue,
      "id": venue.venueId,
      "name": venue.venueName,
      "menuLink": venue.links
    }
    return from(API.patch('portal', `venues?id=${venue.venueId}`, { body: venuePayload }));
  }


}